import * as React from 'react';
import {  getTheme, mergeStyleSets, FontWeights,  Modal,  
    //IconButton
} from 'office-ui-fabric-react';
import { FontSizes } from '@uifabric/styling';
import "./common.scss";

export interface IProps{
    itemid:string
    onClose;
    URL;
  }

  export default class CRMEditFrom extends React.Component<IProps,{}>{
  
    constructor(props: IProps) {
      
      super(props);  
      this.RegisterEvent();
        
    } 
      messageHandler=(event)=> {
        var data = event.data;

        if (!data || typeof data !== 'object') return;

        switch (data.action) {
            case 'CRMEntityEditSuccess':
                this.props.onClose(data.data);
                break;

            /* case 'edit':
                OpenEntryForm(data.data.type, var_page, data.data.id, '');
                break;

            case 'showdetails':
                ChangePage(data.data.page, data.data.id, data.data.slide);
                break;

            case 'meetingcomplete':
                if (data.data.id && data.data.id !== '') {
                    Meeting.ItemId = data.data.id;
                    Meeting.MarkComplete();
                }
                break; */
        }
    }
    RegisterEvent=()=>{
        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var removeEventMethod = window.removeEventListener ? "removeEventListener" : "detachEvent";
        var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

        
    
        // Detach previous listener (if any)
        window[removeEventMethod](messageEvent, this.messageHandler);
    
        // Attach the new one
        window[eventMethod](messageEvent, this.messageHandler);
    }
    public render() {
        const theme = getTheme();
        const contentStyles = mergeStyleSets({
        container: {
            display: 'flex',
            flexFlow: 'column nowrap',
            alignItems: 'stretch'
        },
        header: [
            // tslint:disable-next-line:deprecation
            theme.fonts['xLargePlus'],
            {
            flex: '1 1 auto',
            borderTop: `4px solid ${theme.palette.themePrimary}`,
            color: theme.palette.neutralPrimary,
            display: 'flex',
            fontSize: FontSizes.xLarge,
            alignItems: 'center',
            fontWeight: FontWeights.semibold,
            padding: '12px 12px 14px 24px'
            }
        ],
        body: {
            flex: '4 4 auto',
            padding: '0 24px 24px 24px',
            overflowY: 'hidden',
            selectors: {
            p: {
                margin: '14px 0'
            },
            'p:first-child': {
                marginTop: 0
            },
            'p:last-child': {
                marginBottom: 0
            }
            }
        }
        });

        /* const iconButtonStyles = mergeStyleSets({
        root: {
            color: theme.palette.neutralPrimary,
            marginLeft: 'auto',
            marginTop: '4px',
            marginRight: '2px'
        },
        rootHovered: {
            color: theme.palette.neutralDark
        }
        }); */
        
      return (        
         
          <React.Fragment>
              <Modal
                  titleAriaId={this.props.itemid}
                  subtitleAriaId={this.props.itemid}
                  isOpen={true}
                  //onDismiss={() => this.props.onClose(false)}
                  onDismiss={() => console.log('close')}
                  isBlocking={true}
                  containerClassName={contentStyles.container}
                /* dragOptions={this._dragOptions} */
                >
                  {/* <div className={contentStyles.header}>
                    <span id={this.props.itemid}></span>
                   
                    <IconButton
                      styles={iconButtonStyles}
                      iconProps={{ iconName: 'Cancel' }}
                      ariaLabel="Close popup modal"
                      onClick={() => this.props.onClose(false)}
                    />
                  </div> */}
                  <div className='ms-Grid-row'>
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                    <iframe src={this.props.URL} className='crmframe'
                       frameBorder="0" scrolling="yes" allowFullScreen={true} title="CRM form" />
                      
                    </div>
                  </div>
                  
                </Modal>
                          
          </React.Fragment>
        
      );
    }
    
  
  }
  
  